import { Toolbar } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';

export default styled(Toolbar)(() => ({
    justifyContent: 'space-between',
    gutters: {
        padding: 0,
    },
}));
